/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS GPS lost detection api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Modelling a date time range
 * @export
 * @interface TimeRangeSchema
 */
export interface TimeRangeSchema {
    /**
     * time range lower/beginning date time
     * @type {any}
     * @memberof TimeRangeSchema
     */
    lower?: any | null;
    /**
     * time range upper/ending date time
     * @type {any}
     * @memberof TimeRangeSchema
     */
    upper?: any | null;
}

/**
 * Check if a given object implements the TimeRangeSchema interface.
 */
export function instanceOfTimeRangeSchema(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TimeRangeSchemaFromJSON(json: any): TimeRangeSchema {
    return TimeRangeSchemaFromJSONTyped(json, false);
}

export function TimeRangeSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeRangeSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lower': !exists(json, 'lower') ? undefined : json['lower'],
        'upper': !exists(json, 'upper') ? undefined : json['upper'],
    };
}

export function TimeRangeSchemaToJSON(value?: TimeRangeSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lower': value.lower,
        'upper': value.upper,
    };
}

